angular.module('ui2.0Controllers').controller('aeTagCreationController', ['$scope', '$uibModal', '$rootScope', '$location', '$templateCache', '$compile', '$timeout', '$http', '$window', '$anchorScroll', 'urlFactory', '$routeParams', '$sce', '$document', '$route', '$filter', '$q',"aeService", function ($scope, $modal, $rootScope, $location, $templateCache, $compile, $timeout, $http, $window, $anchorScroll, urlFactory, $routeParams, $sce, $document, $route, $filter, $q,aeService) {
    $scope.itemData = $scope.currentMetaDataItem;
    $scope.popUpData = {
        popupTitle:($scope.fromClause ? intl_msg[23678] + " Feedback" : $scope.isAddMetaData ? "Tag MetaData" : intl_msg[30967] + " Feedback"),
        selectedField:{},
        applicableCategories:[],
        newCategory:{}
    }
    if($scope.isClauseEdit) {

        $scope.popUpData.popupTitle = "Update " + intl_msg[23678] + " Data";
    }
    $scope.init = () => {
        let attrs = {
            scope:$scope,
            currentCategoryId: $scope.itemData && $scope.itemData.id,
            fieldId: $scope.itemData && $scope.itemData.fieldId,
            currentProjectId:$scope.projectId,
        }
        if($scope.fromClause) {
            aeService.getApplicableCategory(attrs);
        }else {
            aeService.getMetaDataFIelds(attrs);
        }
    }
    $scope.tagsList = [];
    $scope.fields = [];

    $scope.taggableText = $scope.itemData.text

    $scope.activeIndex = {value:0};
    $scope.contextmenu = false;
    $scope.contextmenuX = 0;
    $scope.contextmenuY = 0;
    $scope.disableContextMenu = () =>{
        $scope.contextmenu= false;
    }
    $scope.onRightClick = function(e){
        let sel = window.getSelection(),
            text = sel.toString();
        if( !sel.getRangeAt || !sel.rangeCount || !text )
            return;
        let cont = document.querySelector(".modal-dialog")?.getBoundingClientRect();
        $scope.contextmenuX=e.clientX - cont?.left;
        $scope.contextmenuY=e.clientY - cont?.top;
        $timeout(()=>{
            $scope.contextmenu=true;
            $scope.$apply();
        },0)
    }
    $scope.disableContextMenu = () => {
        $scope.contextmenu= false;
    }
    $scope.tagIt = ()=> {
        let sel = window.getSelection(),
            text = sel.toString();
        let range = sel.getRangeAt(0);
        $scope.tagsList.push(text);
        range.deleteContents();
        let span = document.createElement("span");
        span.className = "tag ";
        span.innerHTML = text;
        range.insertNode(span);
        $scope.updateData();
        $scope.disableContextMenu();
        $scope.contextmenu = false;
    }
    $scope.updateData = ()=>{
        let node = $("#activeTaggable");
        $scope.taggableText = node.html();
    }
    $scope.resetTags = () => {
        $scope.tagsList = [];
        $scope.taggableText = $scope.itemData.text;
        $("#activeTaggable").html($scope.itemData.text);
    }

    $scope.submitData = () => {
        if($scope.fromClause && !_.get($scope.popUpData,"newCategory.id"))
            return;
        let attrs = {
            scope:$scope,
            itemData: $scope.itemData,
            popupData: $scope.popUpData,
            fieldId: _.get($scope.popUpData,"selectedField.id"),
            taggedText: $scope.taggableText,
            tagList: $scope.tagsList
        }
        if($scope.isAddMetaData){
            attrs.selectedObj = $scope.itemData.fields.find(item => item.id == _.get($scope.popUpData,"selectedField.id"))
        }
        if($scope.isClauseEdit) {
            let popUpData = {
                newCategory: $scope.popUpData.newCategory,
                pageNo: $scope.itemData.pageno,
                newText: $scope.itemData.text,
                coordinates: $scope.itemData.coordinates,
                score: $scope.itemData.score,
                textId: $scope.itemData.textId,
                closeHandler: $scope.cancelHandler
            };
            let attrs = {
                scope:$scope,
                popupData: popUpData,
                actionType: 2
            }
            aeService.createUpdateClauses(attrs)
        }else {
            aeService.sendClauseFeedback(attrs)
        }
    }
    $scope.resetPopupData = () => {
        $scope.itemData.isTruncated = true;
        $scope.currentMetaDataItem = null;
    }

    $timeout(() => {
        $scope.contextElm = document.getElementById('activeTaggable');

        !$scope.fromClause && $scope.contextElm  && $scope.contextElm.addEventListener('contextmenu', e => {
            // e.preventDefault();
            $scope.onRightClick(e);
        });
    },0)

    $scope.cancelHandler = () => {
        $scope.tagCreationDialogInstance.close();
    }

    $scope.init();

    $scope.$on('$destroy', function () {
        $scope.resetPopupData();
        let contextElm = document.getElementById('activeTaggable');
        contextElm && contextElm.removeEventListener('contextmenu');
    });

}]);
